import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/assets/css/common/common.css';

//i18n为中英文切换语言包
import i18n from '@/assets/i18n/index'

createApp(App).use(store).use(router).use(i18n).mount('#app')
